import { useEffect } from "react";

const upsert = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!value) { el?.remove(); return; }
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", value);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!href) { el?.remove(); return; }
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
  el.setAttribute("href", href);
};

// Per-route meta. On the deployed site (with bot prerendering on) crawlers see these
// absolute URLs resolved against the real host; the static index.html stays the floor.
export const Seo = ({ title, description, image, imageAlt, noindex = false }) => {
  useEffect(() => {
    const origin = window.location.origin;
    const url = `${origin}${window.location.pathname}`;
    const img = image ? `${origin}${image}` : "";
    document.title = title;
    upsert("name", "description", description);
    upsert("property", "og:title", title);
    upsert("property", "og:description", description);
    upsert("property", "og:url", url);
    upsert("property", "og:image", img);
    upsert("property", "og:image:width", img ? "1200" : "");
    upsert("property", "og:image:height", img ? "630" : "");
    upsert("property", "og:image:alt", img ? imageAlt || title : "");
    upsert("name", "twitter:card", img ? "summary_large_image" : "summary");
    upsert("name", "twitter:title", title);
    upsert("name", "twitter:description", description);
    upsert("name", "twitter:image", img);
    upsertLink("canonical", noindex ? "" : url);
    upsert("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
  }, [title, description, image, imageAlt, noindex]);
  return null;
};
